import React from "react"
import maintenance from "../assets/maintenance.png"

function Unavailable() {
  return (
    <div className="unavailable-page-container">
      <div className="unavailable-container">
        <img src={maintenance} alt="Maintenance" className="maintenance-img" />
        <div className="text-container">
          <h2> Feature coming soon </h2>
          <h4>
            Hold tight, we're just making sure that this feature is perfect for
            you! Check back again later.
          </h4>
        </div>
      </div>
    </div>
  )
}

export default Unavailable
